import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';

import { useTheme } from '@material-ui/styles';

import {
    Text,
    Tag,
    ContainedButton,
    ArticleIcon,
    TagDetail,
    CrossIcon,
    StyledCard,
    StyledCardContent,
    Checkbox,
    CheckboxGroup,
    FormGroup,
    Avatar,
} from '../../index';

import { StyledActivityCheckBoxContainer } from './style';

import { ACTIVITIES } from '../../../constant';

const MindGymIcon = '/resources/images/mindgym/mindgym-icon.svg';

export const QuickNoteTag = ({
    onAddNote,
    onAddNewTag,
    tagContainerWidth,
    data,
    possibleActivity,
    handleSelectPossibleActivity,
}) => {
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);

    const onClose = () => {
        setAnchorEl(null);
    };

    const onAdd = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const onSave = (value) => {
        onAddNewTag(value);
    };

    /*--------------- Activity popover ---------------*/
    const [anchorActivity, setAnchorActivity] = useState(null);
    const handleClickMindGym = (event) => {
        setAnchorActivity(event.currentTarget);
    };
    const handleClosePopover = () => {
        setAnchorActivity(null);
    };
    const open = Boolean(anchorActivity);

    return (
        <div
            style={{
                backgroundColor: 'white',
                boxShadow:
                    '0px -2px 4px rgba(174, 180, 210, 0.4), inset 0px -2px 4px rgba(174, 180, 210, 0.2)',
                position: 'relative',
                paddingTop: '20px',
            }}
        >
            {possibleActivity && handleSelectPossibleActivity && (
                <Popover
                    open={open}
                    anchorEl={anchorActivity}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 270,
                        horizontal: 'right',
                    }}
                    PaperProps={{ style: { borderRadius: '16px' } }}
                >
                    <StyledCard
                        $width="285px"
                        $backgroundColor="white"
                        padding="16px 0 16px 16px"
                        style={{ height: '260px' }}
                    >
                        <StyledCardContent>
                            <Text $fontSize="16px" $medium>
                                Possible Activity
                            </Text>
                            <CheckboxGroup component="fieldset" style={{}}>
                                <FormGroup
                                    row
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        height: '180px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {Object.keys(ACTIVITIES).map((type, index) => (
                                        <Fragment key={`activity_${type}`}>
                                            <StyledActivityCheckBoxContainer
                                                onClick={() => handleSelectPossibleActivity(type)}
                                            >
                                                <Avatar
                                                    alt={`logo ${ACTIVITIES[type].title}`}
                                                    src={ACTIVITIES[type].icon}
                                                    $avatarSize="24px"
                                                />
                                                <Text $fontSize="12px" style={{ flexGrow: 1 }}>
                                                    {ACTIVITIES[type].title}
                                                </Text>
                                                <Checkbox
                                                    checked={possibleActivity?.some(
                                                        (a) => a === type
                                                    )}
                                                />
                                            </StyledActivityCheckBoxContainer>
                                            {Object.keys(ACTIVITIES).length !== index + 1 && (
                                                <div
                                                    style={{
                                                        height: '1px',
                                                        width: '100%',
                                                        background: theme.palette.common.gray6,
                                                        margin: '3px 16px 3px 0',
                                                    }}
                                                ></div>
                                            )}
                                        </Fragment>
                                    ))}
                                </FormGroup>
                            </CheckboxGroup>
                        </StyledCardContent>
                    </StyledCard>
                </Popover>
            )}

            <TagDetail
                anchorEl={anchorEl}
                placement={'top-end'}
                popperStyle={{ marginTop: '10px', marginBottom: '10px' }}
                onSave={onSave}
                onClose={onClose}
            />
            <Text $fontSize="18px" $bold style={{ marginLeft: '20px' }}>
                Quick Note Tag
            </Text>
            {possibleActivity && handleSelectPossibleActivity && (
                <ContainedButton
                    $icon
                    $backgroundColor="blue13"
                    style={{
                        width: '48px',
                        height: '48px',
                        position: 'absolute',
                        top: '-24px',
                        right: '85px',
                    }}
                    onClick={handleClickMindGym}
                >
                    {open ? (
                        <CrossIcon width="30" height="30" />
                    ) : (
                        <img src={MindGymIcon} alt="MindGymIcon" />
                    )}
                </ContainedButton>
            )}
            <ContainedButton
                $icon
                $backgroundColor="purple"
                style={{
                    width: '48px',
                    height: '48px',
                    position: 'absolute',
                    top: '-24px',
                    right: '20px',
                }}
                onClick={() => onAddNote()}
            >
                <ArticleIcon />
            </ContainedButton>
            <div
                style={{
                    marginTop: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    overflowX: 'auto',
                    width: `${tagContainerWidth}px`,
                    paddingBottom: '25px',
                    paddingLeft: '20px',
                    columnGap: '5px',
                }}
            >
                {data?.map((tag) => (
                    <Tag key={tag.id} onClick={() => onAddNote(tag)}>
                        {tag.name}
                    </Tag>
                ))}
                <Tag
                    $color="primaryBlue"
                    style={{
                        backgroundColor: 'transparent',
                        marginRight: '20px',
                    }}
                    onClick={onAdd}
                >
                    + Add new tag
                </Tag>
            </div>
        </div>
    );
};

QuickNoteTag.propTypes = {
    tagContainerWidth: PropTypes.number,
    data: PropTypes.array.isRequired,
    onAddNote: PropTypes.func.isRequired,
    onAddNewTag: PropTypes.func.isRequired,
};
